export const sortAdminLanguages = (languages: string[]): string[] => {
  const priority: Record<string, number> = {
    fr: 0,
    en: 1,
    es: 2
  };

  return [...languages].sort((a, b) => {
    const aCode = (a || '').toLowerCase();
    const bCode = (b || '').toLowerCase();
    const aRank = priority[aCode] ?? 99;
    const bRank = priority[bCode] ?? 99;

    if (aRank !== bRank) return aRank - bRank;
    return aCode.localeCompare(bCode);
  });
};
